import styled from '@emotion/styled';
import { DSStyledContent } from '@hundred5/design-system';

export const QuestionDescription = styled(DSStyledContent)`
  font-weight: 500;
  padding: 24px;
  max-width: 100%;
  overflow: auto;
`;
